export default {
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.reset_sale': 'Reset Sale',
    'common.previewPolicy': 'Preview policy',
    'common.confirmDelete': 'Confirm to delete?',
    'common.general': 'General Information',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.add': 'Add',
    'common.plate': 'Plate',
    'common.continueManually': 'Continue Manually',
    'common.continue': 'Continue',
    'common.back': 'Back',
    'common.buy': 'Buy',
    'common.sell': 'Sell',
    'common.clear': 'Clear',
    'common.filter': 'Filter',
    'common.actions': 'Actions',
    'common.add.permission': 'Add Permissions',
    'common.add.role': 'Add Roles',
    'common.search.here': 'Search here...',
    'common.loading': 'Loading...',
    'common.seeLess': 'See less',
    'common.seeMore': 'See more',
    'common.coverages': 'Coverages',
    'common.durations': 'Durations',
    'common.stocks': 'Stocks',
    'common.templates': 'Templates',
    'common.basePolicy.addPolicy': 'Add {firstArg} Policy',
    'common.Waiting for the server': 'Waiting for the server....',
    'common.premiumStructure': 'Premium Structure',
    'common.Participating parties': 'Participating parties',
    'common.Insured Items': 'Insured Items',
    'common.Policy PDF': 'Policy Copy',
    'common.Comments': 'Comments',
    'common.assets': 'Assets',
    'common.Policy Dates': 'Policy Dates',
    'common.Other Informations': 'Other Informations',
    'common.Clients': 'Clients',
    'common.Beneficiaries': 'Beneficiaries',
    'common.Co-Insurers': 'Co-Insurers',
    'common.Insurers': 'Insurers',
    'common.Insured': 'Insured',
    'common.EditDescription': 'Edit Description',
    'common.AddDescription': 'Add Description',
    'common.PolicyHolder': 'Policy Holders',
    'common.InvoiceRecipients': 'Invoice Recipients',
    'common.emptyPolicy': 'This policy does not have any insured object/coverage!',
    'common.flat': 'Flat',
    'common.total': 'Total',
    'common.noViews': 'No views',
    'common.searchAddress': 'Search Address',
    'common.selectRecord': 'Select Record',
    'common.info': 'Personal Information',
    'common.Policies': 'Policies',
    'common.Documents': 'Documents',
    'common.Customer Policies': 'Customer Policies',
    'common.Premiums': 'Premiums',
    'common.Claims': 'Claims',
    'common.quickReports': 'Quick Reports',
    'common.ratio': 'Premium/Claim Ratio',
    'common.unpaidObligations': 'Table of unpaid obligations',
    'common.comments': 'Comments',
    'common.Address': 'Address & Contact',
    'common.enable': 'Enable:',
    'common.Fixed value': 'Fixed value',
    'common.Upload documents': 'Upload documents',
    'common.upload': 'Click or drag file to this area to upload',
    'common.file': 'file',
    'common.uploaded': 'uploaded',
    'common.removed': 'removed',
    'common.successfully': 'successfully',
    'common.updated': 'updated',
    'common.created': 'created',
    'common.searchVin': 'Search the chassis in the system by the license plate',
    'common.SearchVin': 'Search the chassis',
    'common.enterPlate': 'Enter the license plate of the vehicle...',
    'common.vin': 'Chassis',
    'common.enterVin': 'Please enter the chassis!',
    'common.enterVinPlease': 'Enter the vehicle chassis...',
    'common.Classification Tpl': 'Classification Tpl',
    'common.City': 'City',
    'common.Category': 'Category',
    'common.Vin': 'Vin',
    'common.Make': 'Make',
    'common.Model': 'Model',
    'common.Engine': 'Engine',
    'common.Volume': 'Volume',
    'common.Fuel': 'Fuel',
    'common.Capacity': 'Capacity',
    'common.Color': 'Color',
    'common.Seats': 'Seats',
    'common.Year': 'Year',
    'common.fillInVehicle': 'Fill in the vehicle data',
    'common.Classification': 'Classification',
    'common.Type': 'Type',
    'common.writeComment': 'Write the comment...',
    'common.finalizeSale': 'Finalize Sale',
    'common.Add Comment': 'Add Comment',
    'common.Add': 'Add',
    'common.policyParticipants': 'Policy participants',
    'common.participants01': 'The bill is made to the leader',
    'common.participants02': 'Invoice to be divided according to participation in percentage',
    'common.participants03': 'The invoice is made 100% to the customer',
    'common.participants04': 'The invoice is made to the client according to the percentage',
    'common.participants05': 'The invoice is made to the leader according to the percentage',
    'common.warning': 'Warning',
    'common.Renewals': 'Renewals',
    'common.years': 'years',
    'common.months': 'months',
    'common.days': 'days',
    'common.Custom': 'Custom',
    'common.Renewable': 'Renewable',
    'common.Renewable Frequency': 'Renewable Frequency',
    'common.Month': 'Month',
    'common.Confirm': 'Confirm',
    'common.blocker': 'Are you sure you want to leave this page?',
    'common.afterBlocker': 'Changes will not be saved!',
    'common.LogOut': 'Log out',
    'common.changePassword': 'Change Password',
    'common.areUsure': 'Are you sure you want to finalize this sale?',
    'common.clickConfirm': "Click 'Confirm' if you want to see Policy PDF",
    'common.Period': 'Period',
    'common.Today': 'Today',
    'common.This week': 'This week',
    'common.This month': 'This month',
    'common.Last month': 'Last month',
    'common.This year': 'This year',
    'common.Last year': 'Last year',
    'common.Coverage': 'Coverage',
    'common.Duration': 'Duration',
    'common.Stock': 'Stock',
    'common.Template': 'Template',
    'common.Template Items': 'Template Items',
    'common.Premium': 'Premium',
    'common.Set Percentage': 'Set Percentage',
    'common.Driver': 'Driver',
    'common.Owner': 'Owner',
    'common.REMOVE': 'REMOVE',
    'common.EDIT': 'Edit',
    'common.Add Driver': 'Add Driver',
    'common.Update Driver': 'Update Driver',
    'common.Same as owner': 'The driver is the same as the owner',
    'common.Same as policyHolder': 'The drivers is the same as policy holder',
    'common.Write the Serial': 'Write the Serial',
    'common.Serials in Condition': 'Serials in Condition',
    'common.reserveSerial': 'Reserve a serial',
    'common.serialRequiredToReserve': 'There is no serial to reserve',
    'common.select': 'Select',
    'common.serialReserved': 'Serial {serial} reserved successfully',
    'common.useReservedSerial': 'Use a reserved serial',
    'common.selectReservedSerial': 'Select a reserved serial',
    'common.noReservedSerials': 'This product has no reserved serials yet',
    'common.Premium Structure': 'Premium Structure',
    'common.Policy Documents': 'Policy Documents',
    'common.TPLpolicy': 'TPL Policy',
    'common.TPLcompany': 'TPL Company',
    'common.calculatedPremium': 'The calculated premium is',
    'common.changePremium': 'If you want to change the premium',
    'common.place': 'Place',
    'common.coveragesNull': 'This product does not have coverages. Check product configurations!',
    'common.Selected': 'Selected',
    'common.sumInsured': 'The sum insured',
    'common.driversAreSame': 'Drivers are the same as TPL',
    'Fixed value': 'Fixed value',
    damage: 'damage',
    '% damage': '% damage',
    'Min % damage': 'Min % damage',
    'Max % damage': 'Max % damage',
    'of the sum insured': 'of the sum insured',
    '% of the sum insured': '% of the sum insured',
    'Min % of the sum insured': 'Min % of the sum insured',
    'Max % of the sum insured': 'Max % of the sum insured',
    'common.resetFilters': 'Reset Filters',
    'common.resetColumns': 'Reset Columns',
    'common.close': 'Close',
    'endingPolicies.period': 'Policies expiring between {firstArg} and {secondArg}',
    'endingPolicies.total': 'Total policies: {firstArg}',
    'endingPolicies.totalLabel': 'Total',
    'endingPolicies.view': 'View policies',
    'common.No internet connection!': 'No internet connection!',
    'common.Reload page': 'Reload Page',
    'common.autosos': 'AutoSOS - Fill in the fields below',
    'common.autosos.question': 'Do you want to remove AutoSOS coverage?',
    'common.Add New': 'Add New',
    'common.Add New Row': 'Add new row',
    'common.add New Payment': 'Add new payment',
    'common.User Info': 'User Info',
    'common.Create User': 'Create User',
    'common.create': 'Create',
    'common.saveVehicleData': 'Save Vehicle Data',
    'common.Check Balance': 'Check Balance',
    'common.Error occurred:': 'Error occurred:',
    'common.Something went wrong. Please contact IT department!': 'Something went wrong. Please contact IT department!',
    'common.Policy Holder': 'Policy Holder',
    'common.Add Client': 'Add Client',
    'common.Client Card': 'Client Card',
    'common.Client Info': 'Client Info',
    'common.Insured People': 'Insured People',
    'common.Settings': 'Settings',
    'common.insurerTeller': 'The policy is being sold for',
    'common.amfTeller': 'Të dhënat e mjetit kanë ardhur nga AMF dhe nuk mund të ndryshohen.',
    'common.validate': 'Validate',
    'common.noticeDateInfo': "To save the date press 'Enter'",
    'common.warning.notice': 'New changes have occurred in the system. Please reload page!',
    'common.Clients Terms': 'Clients Terms',
    'common.fillInContactType': 'Fill out Contact Type',
    'common.carefulWarning': 'Careful! You are not selling with',
    'common.insurerThatIsSelling': 'You are selling for:',
    'common.youSure': 'Are you sure you want to continue?',
    'common.refreshLogo': 'Refresh logo',
    'common.showMore': 'Show More',
    'common.showLess': 'Show Less',
    'common.vehicleInfo': 'Vehicle Information',
    'common.listOfObjects': 'List of objects',
    'common.addObjects': 'Add object',
    'common.fillObjects': 'Fill object',
    'common.nr': 'Nr',
    'common.fillCityBefore': 'Insert city before!',
    'common.Export as CSV': 'Export as CSV',
    'common.Export as Excel': 'Export as Excel',
    'common.premium': 'Premium',
    'common.calculated': 'Calculated',
    'common.serialClickHint': 'Click twice on the serial you want',
    'common.SerialClickHint': 'Click on the serial you want',
    'common.companyLogo': 'Company Logo',
    'common.View the PDF': 'Print the policy',
    'common.ownerBlocked': 'The owner is locked and cannot be changed',
    'common.emailSenderInfo': "To send the policy to the client's e-mail, please fill in the field below. If not, don't fill it out.",
    'common.downloadExcel': 'Select the date range when the policies were issued and click "Confirm" to export them!',
    'common.noAccess': 'You do not have access',
    'common.changes': 'Changes',
    'Select Product': 'Select Product',
    'Select Account': 'Select Account',
    modifyPolicy: 'Modify Policy',
    uploaded: 'uploaded',
    removed: 'removed',
    successfully: 'successfully',
    'common.Drivers': 'Drivers',
    'common.disabledButtonTooltip': 'The license plate search is inactive because policy is being renewed',
    'buttonDisabled.renewal': 'The button is deactivated because the renewal functionality has not been completed!',
    'buttonDisabled.duplication': 'The button is disabled because the duplication functionality is not finished!',
    'buttonDisabled.premiumReturned': 'The button is disabled because the premium return functionality has not been completed for this kind of policy!',
    'buttonDisabled.cancel': 'The button is disabled because the policy has already been cancelled!',
    'buttonDisabled.cancelPermission': 'You have no permission!',
    'Modification of the policy': 'Modification of the policy',
    'Policy holders': 'Policy holders',
    Beneficiary: 'Beneficiary',
    Insurers: 'Insurers',
    Insured: 'Insured',
    'Select All Agencies': 'Select All Agencies',
    'Deselect All Agencies': 'Deselect All Agencies',
    'Less than': 'Less than',
    'Greater than': 'Greater than',
    'Less than or equal': 'Less than or equal',
    'Greater than or equal': 'Greater than or equal',
    'In range': 'In range',
    from: 'from',
    to: 'to',
    Equals: 'Equals',
    'Not equal': 'Not equal',
    Blank: 'Blank',
    'Not blank': 'Not blank',
    'Choose One': 'Choose One',
    Contains: 'Contains',
    'Not contains': 'Not contains',
    'Starts with': 'Starts with',
    'Ends with': 'Ends with',
    AND: 'AND',
    OR: 'OR',
    Apply: 'Apply',
    Reset: 'Reset',
    ResetData: 'Reset Data',
    Clear: 'Clear',
    Cancel: 'Cancel',
    Filters: 'Filters',
    Columns: 'Columns',
    Limits: 'Limits',
    Sublimits: 'Services',
    SingleYear: 'Year',
    'Motor Policies': 'Motor Policies',
    'Health Policies': 'Health Policies',
    Canceled: 'Canceled',
    Issued: 'Issued',
    Drafted: 'Drafted',
    NoStatus: 'No Status',
    Returned: 'Returned',
    Cancelled: 'Cancelled',
    Blocked: 'Blocked',
    Duplicated: 'Duplicated',
    Draft: 'Draft',
    Modified: 'Modified',
    'common.noticeForExport': 'You can export policies to CSV/EXCEL in the buttons on the right',
    'common.NoticeForExport': 'You can export policies to CSV/EXCEL using the buttons underneath.',
    'common.chooseRenewalsFirst': 'Choose years of renewals to calculate End Date!',
    'common.writeHere': 'You can write policy description right here...',
    'common.RolesNotify': 'Add Permissions to this Role. Users who have this Role will receive all Permissions below that match the API of their login request.',
    'common.Assign Permission': 'Assign Permission',
    'Search permission': 'Search permission',
    'common.Remove permission?': 'Are you sure you want to remove this permission?',
    'common.areUSure': 'Are you sure for this action?',
    'common.updatePassword': 'Update password',
    searchProduct: 'Search product',
    'Insured object description': 'Insured object description',
    'Installments & Renewals': 'Installments & Renewals',
    'Total installments': 'Total installments',
    'Do you want to be the same as the beneficiary?': 'Do you want to be the same as the beneficiary?',
    'Do you want to be the same as the policy holder?': 'Do you want to be the same as the policy holder?',
    'Motor Product': 'Motor Product',
    'You want to select the address on the map?': 'You want to select the address on the map?',
    'Companion Policy': 'Companion Policy',
    'Change bank': 'Change bank',
    'Add bank': 'Add bank',
    'Delete bank': 'Delete bank',
    'common.bankInfo': 'If the selected option is "bank", you will be given the opportunity to register the bank!',
    'common.noBankBranches': 'Warning: This bank does not have any branches!',
    'Update Notary': 'Update Notary',
    'Add Notary': 'Add Notary',
    'Update Insurance Agent': 'Update Insurance Agent',
    'Add Insurance Agent': 'Add Insurance Agent',
    'common.undefined': 'Value is not defined',
    'common.Bank': 'Bank',
    'common.Agent': 'Agent',
    'common.Client': 'Client',
    'common.Invoice': 'Invoice',
    'common.valueLCY': 'Value ALL',
    Add: 'Add',
    Update: 'Update',
    'Select bank branch': 'Select bank branch',
    Configurations: 'Configurations',
    'All Configurations': 'All configurations',
    'Product Configurations': 'Product Configurations',
    'Agency Configurations': 'Agency Configurations',
    'Product Template Configurations': 'Product Template Configurations',
    'Add Bank Branch': 'Add Bank Branch',
    'Bank Branch': 'Bank Branch',
    noBankBranches: 'This bank does not have any bank branch',
    'Remove according to the authorization': 'Remove "According to the Authorization"',
    'Add according to the authorization': 'Add "According to the Authorization"',
    'Object Value': 'Object Value',
    'Is Approved': 'Is Approved',
    'Add insured person': 'Add insured person',
    'List of Persons': 'List of Persons',
    'Assign Role': 'Assign Role',
    'Assign Permission': 'Assign Permission',
    Assignment: 'Assignment',
    Permission: 'Permission',
    'Empty Mass': 'Empty Mass',
    'Shto broker': 'Shto broker',
    Përdoruesit: 'Users',
    'Fill in the fields': 'Fill in the fields',
    'Select the invoice': 'Select the invoice',
    'Fill in the account type and its value!': 'Fill in the account type and its value!',
    'For the applied filters:': 'For the applied filters:',
    'Please fill in the account first to display the list of balances!': 'Please fill in the account first to display the list of balances!',
    Export: 'Export',
    Print: 'Print',
    From: 'From',
    To: 'To',
    'Cumulative Balance': 'Cumulative Balance',
    Importi: 'Importi',
    'Accidental Damages Duration': 'Accidental Damages Duration',
    renew: 'Renew',
    edit: 'Edit',
    cancellationOrder: 'Cancellation order',
    arrangement: 'Arrangement',
    duplicate: 'Duplicate',
    annex: 'Annex',
    printIndividual: 'Individual Print',
    printCollective: 'Collective Print',
    reprint: 'Reprint',
    cancel: 'Cancel',
    deletePremiumDifferenceAdjustment: 'Delete Adjustment',
    selectProductsThatAgentCanAdjustPremium: 'Select products for which agent can adjust premium',
    selectpaymentMethodForCascoProduct: 'Select payment method for Casco product',
    activateCustomPackages: 'Activate Custom Packages',
    activateCustomPackge: 'Activate Custom Package',
    searchProductByName: "Search Product By Name...",
    searchPaymentType: "Search Payment Type...",
    participantsInheritance: "Participants Inheritance",
};
